import { render, staticRenderFns } from "./modalDocumentoVenda.vue?vue&type=template&id=6c5ed16c&scoped=true&"
import script from "./modalDocumentoVenda.vue?vue&type=script&lang=js&"
export * from "./modalDocumentoVenda.vue?vue&type=script&lang=js&"
import style0 from "./modalDocumentoVenda.vue?vue&type=style&index=0&id=6c5ed16c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5ed16c",
  null
  
)

export default component.exports